import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=72ceaf78&scoped=true"
import script from "./Part2.vue?vue&type=script&lang=js"
export * from "./Part2.vue?vue&type=script&lang=js"
import style0 from "./Part2.vue?vue&type=style&index=0&id=72ceaf78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ceaf78",
  null
  
)

export default component.exports